import React, { Component } from "react";
import { HashRouter } from "react-router-dom";
import Routes from "./Routes";

export default class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      snack_open: false,

    };
    this.closeSnack = this.closeSnack.bind(this);
  }
  closeSnack() {
    this.setState({ snack_open: false });
  }
  componentDidMount() {

  }
  render() {

    return (
        <div style={{ height: "100%", width: "100%"}}>
        <HashRouter>
          <Routes />
        </HashRouter>
        </div>
    );
  }
}
